import { useQuery } from 'react-query';
import { getExpenseAccounts } from '../../../../../actions/Utilities/VendorConfiguration';


export default function useGetExpenseAccounts() {
  return useQuery("useGetExpenseAccounts", getExpenseAccounts, {
    refetchOnWindowFocus: false,
  });
}

